import { API_URLS } from "../config/apiUrls";
import { selecionarUltimaVersao } from "./selecionarUltimaVersao";
import { DocumentoLegal, LegalTipo } from "./tipos";

export type DocumentosPorTipo = Partial<Record<LegalTipo, DocumentoLegal>>;

const agruparUltimasVersoes = (
  documentos: DocumentoLegal[],
  tipos: LegalTipo[],
): DocumentosPorTipo => {
  const agrupados: DocumentosPorTipo = {};

  tipos.forEach((tipo) => {
    const ultimo = selecionarUltimaVersao(documentos, tipo);
    if (ultimo) agrupados[tipo] = ultimo;
  });

  return agrupados;
};

/**
 * Busca a versão mais recente de cada tipo pedido. `GET /legal` devolve todos os
 * documentos de uma vez e é rota pública — nenhum token é enviado, para
 * funcionar em páginas sem login.
 *
 * await buscarDocumentosLegais(["PRIVACY_POLICY", "TERMS_OF_USE"])
 */
export const buscarDocumentosLegais = async (
  tipos: LegalTipo[],
): Promise<DocumentosPorTipo> => {
  const resposta = await fetch(API_URLS.legal);

  if (!resposta.ok) {
    throw new Error(
      `GET ${API_URLS.legal} respondeu ${resposta.status}; esperado 200 com um array de documentos legais`,
    );
  }

  const documentos: DocumentoLegal[] = await resposta.json();
  return agruparUltimasVersoes(documentos, tipos);
};
